module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('a', {
    staticClass: "primary-button",
    class: {
      'disabled': _vm.disabled
    },
    attrs: {
      "href": _vm.route.path
    },
    on: {
      "click": _vm.clicked
    }
  }, [_c('span', {
    class: {
      hidden: _vm.loading
    }
  }, [_vm._t("default")], 2), (_vm.loading) ? _c('loading', {
    attrs: {
      "mini": true,
      "alt": true
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f93446d","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/elements/PrimaryButton.vue
// module id = /cSv
// module chunks = 0 1